import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const getActionReporter = (startTime: number, additionalContext = {}) => {
  return () => {
    const loadEnd = performance.now();
    const loadTime = loadEnd - startTime;
    datadogRum.addAction('Loading Viewed', {
      duration: loadTime,
      ...additionalContext
    });
  };
};

function useLoadTimeTracking(additionalContext = {}) {
  useEffect(() => {
    try {
      const loadStart = performance.now();
      const actionReporter = getActionReporter(loadStart, additionalContext);
      window.addEventListener('beforeunload', actionReporter);
      return () => {
        try {
          window.removeEventListener('beforeunload', actionReporter);
          actionReporter();
        } catch (error) {
          console.error('Error reporting load time', error);
        }
      };
    } catch (error) {
      console.error('Error starting load time tracking', error);
    }
  });
}

export default useLoadTimeTracking;
